import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    active_chat: null,
    chat_to_load: null,
    list: [],
    chats_menu: true,
};

const chatsSlice = createSlice({
    initialState,
    name: "chats",
    reducers: {
        set_chat_active: (state, action) => {
            state.active_chat = action.payload;
            return state
        },
        set_chat_to_load: (state, action) => {
            state.chat_to_load = action.payload;
            return state
        },
        set_chats: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
        reset_chats: (state) => {
            return {
                ...initialState,
                chat_to_load: state.chat_to_load, // Preserve the active_chat
            };
        },
        reset_chat_to_load: (state) => {
            state.chat_to_load = null;
            return state
        },
    }
})

export default chatsSlice.reducer;

export const {
    set_chat_active,
    set_chat_to_load,
    set_chats,
    reset_chats,
    reset_chat_to_load,
} = chatsSlice.actions;
